import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';
import { SnackbarAction } from './snackbar-action.model';
import { SnackbarType } from './snackbar-type.model';
import { SnackbarComponent } from './snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  public config: MatSnackBarConfig = {
    duration: 3000,
    verticalPosition: 'bottom'
  };

  constructor(private snackbar: MatSnackBar, private transloco: TranslocoService) {}

  public open(
    message: string,
    type: SnackbarType = 'info',
    config?: MatSnackBarConfig,
    action?: SnackbarAction
  ): MatSnackBarRef<SnackbarComponent> {
    return this.snackbar.openFromComponent(SnackbarComponent, {
      ...this.config,
      ...config,
      panelClass: 'snackbar-' + type,
      data: {
        action: action,
        message: this.transloco.translate(message || 'Something went wrong'),
        type: type
      }
    });
  }
}
